import { ENDPOINTS, sendAsyncRequest } from '../utils';
import { logger } from '../utils/logger';
import { ServiceDeliveyTypePaginated, ServiceDeliveryTypeAvailables } from '../store/serviceDeleviryTypes/types';

const getServicesDeliveryTypeList = async (page?: number, perPage?: number): Promise<ServiceDeliveyTypePaginated> => {
  const response = await sendAsyncRequest('get', ENDPOINTS.SERVICES, true, { page: page, limit: perPage }, undefined);
  return response.data;
};

const getServiceDeliveryTypeAvailable = async (): Promise<ServiceDeliveryTypeAvailables> => {
  const response = await sendAsyncRequest('get', ENDPOINTS.SERVICES_AVAILABLES, true, undefined, undefined);
  return response.data;
};
const addNewServiceDeliveryType = async (data: { type: string; duration: number; refPat: string }): Promise<void> => {
  await sendAsyncRequest('post', ENDPOINTS.SERVICES, true, undefined, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      logger.error('ServiceDeliveryTypeAPI', 'Error in addNewServiceDeliveryType', { error });
    });
};

const deleteServiceDelivery = async (id: string): Promise<unknown> => {
  const response = await sendAsyncRequest('delete', ENDPOINTS.SERVICES + '/' + id, true, undefined, undefined);
  return response.data;
};

const editServiceDelivery = async (
  id: string,
  data: {
    type: string;
    duration: number;
    refPat: string;
  },
): Promise<unknown> => {
  await sendAsyncRequest('put', ENDPOINTS.SERVICES + '/' + id, true, undefined, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw new Error(error);
    });
};

export const servicesDeliveryType = {
  getServicesDeliveryTypeList,
  addNewServiceDeliveryType,
  deleteServiceDelivery,
  editServiceDelivery,
  getServiceDeliveryTypeAvailable,
};
